import { Paper as MuiPaper, Stack, type StackProps } from "@mui/material";
import { styled } from "@mui/material/styles";

export const Root = styled(Stack)<StackProps>(({ theme }) => ({
  gap: theme.spacing(2),
}));

export const WhiteRoot = styled(MuiPaper)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  flexDirection: "column",
  gap: theme.spacing(2),
  padding: theme.spacing(2),
  backgroundColor: theme.palette.background.default,
  borderRadius: theme.shape.borderRadius,
  border: `0.0625rem solid ${theme.palette.divider}`,
}));
